import ContactForm from "@/pages/about/components/ContactForm";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const services = [
  {
    icon: "ri-play-circle-line",
    title: "高清在线播放",
    desc: "覆盖热门新番与经典老番，清晰流畅，随时随地打开就能看。",
  },
  {
    icon: "ri-apps-2-line",
    title: "丰富分类筛选",
    desc: "按类型、地区、年份与热度多维筛选，快速锁定心仪作品。",
  },
  {
    icon: "ri-search-eye-line",
    title: "便捷搜索体验",
    desc: "关键词即时搜索，支持按相关度、更新时间与评分排序。",
  },
  {
    icon: "ri-heart-3-line",
    title: "收藏随时回看",
    desc: "一键收藏喜欢的动漫，记录保存在本地，下次继续追更。",
  },
];

const stats = [
  { value: "5000+", label: "动漫资源" },
  { value: "10", label: "热门分类" },
  { value: "24h", label: "持续更新" },
  { value: "100%", label: "免费观看" },
];

export default function AboutPage() {
  useDocumentMeta(
    "关于我们 - 动漫免费在观看",
    "了解动漫免费在观看的网站定位、服务内容与联系方式。我们致力于为动漫爱好者提供丰富多样的高清动漫资源与优质在线播放体验。",
    "关于动漫免费在观看,动漫平台介绍,免费动漫网站,动漫在线播放",
  );

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-8 pt-10 md:pt-14 pb-8 md:pb-10 bg-gradient-to-br from-primary-50 to-background-50">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
            <i className="ri-tv-2-line"></i>
            关于我们
          </span>
          <h1 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
            让每一次追番都轻松愉快
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            「动漫免费在观看」是一个专注高清动漫在线播放的免费平台。我们希望用简洁清爽的界面、丰富的分类和顺滑的播放体验，帮助每一位动漫爱好者快速找到想看的内容，随时沉浸在精彩的故事里。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((item) => (
            <div key={item.label} className="bg-background-50 border border-background-200 rounded-lg p-5 text-center">
              <p className="font-heading font-extrabold text-2xl md:text-3xl text-primary-600">{item.value}</p>
              <p className="mt-1.5 text-sm text-foreground-500">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-4">
        <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 mb-2">
          我们提供什么
        </h2>
        <p className="text-sm text-foreground-500 mb-6">围绕观看、发现与收藏，持续打磨你的动漫体验。</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((item, i) => (
            <div key={item.title} className="bg-background-50 border border-background-200 rounded-lg p-5">
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-lg ${
                  i % 3 === 0 ? "bg-primary-100 text-primary-700" : i % 3 === 1 ? "bg-accent-100 text-accent-800" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-6 lg:gap-10 items-start">
          <div className="space-y-6">
            <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-7">
              <h2 className="font-heading font-bold text-xl text-foreground-950 flex items-center gap-2 mb-5">
                <i className="ri-contacts-line text-primary-500"></i>
                联系我们
              </h2>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-mail-send-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-foreground-500 text-xs">邮箱</p>
                    <p className="text-foreground-900 mt-0.5">support@dongmanfree.example</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-phone-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-foreground-500 text-xs">客服热线</p>
                    <p className="text-foreground-900 mt-0.5">400-888-6666</p>
                    <p className="text-foreground-400 text-xs mt-0.5">工作日 9:00 - 18:00</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-map-pin-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-foreground-500 text-xs">地址</p>
                    <p className="text-foreground-900 mt-0.5">上海市浦东新区动漫大道 88 号</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-200 h-[220px]">
              <iframe
                title="动漫免费在观看办公地址地图"
                src="https://mywouhoa.cn/maps?q=Shanghai%20Pudong&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-16">
        <div className="bg-foreground-950 rounded-lg p-6 md:p-8">
          <h2 className="font-heading font-bold text-lg text-background-50 flex items-center gap-2">
            <i className="ri-copyright-line text-primary-400"></i>
            版权声明
          </h2>
          <p className="mt-3 text-sm text-background-300 leading-relaxed">
            本站为前端演示站点，页面中的动漫名称、简介、评分、热度及剧集等信息均为演示数据，播放器为前端模拟控件，不提供、也不存储任何真实视频内容与资源。本站所有素材仅用于产品展示与学习交流，若涉及版权问题请联系我们处理。请支持正版，通过官方渠道观看相关作品。
          </p>
        </div>
      </section>
    </div>
  );
}